<template>
  <div class="container-login">
    
    <div class="form">

            <div class="content-form reset-text-transform">

                <h2>Entre com suas credenciais</h2>

                <el-form @submit.native.prevent="onSubmitLogin" :model="dados" ref="dados" label-position="top" class="u-mt-30 form-login">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="user" :rules="[$requiredBlur]" key="user">
                                <el-input size="medium" id="user" placeholder="Usuário" v-model="dados.user"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="password" :rules="[$requiredBlur]" key="password">
                                <el-input size="medium" id="password" placeholder="Senha" type="password" v-model="dados.password"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button style="width: 123px;" size="medium" :loading="loading" class="btn-login" type="primary" native-type="submit" plain>
                                    <i class="fas fa-sign-in-alt u-mr-5"></i>
                                    Entrar
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>

                </el-form>

                <!-- BLOCO N — item 18: entrada do RESPONSÁVEL pela chave impressa.
                     Não há cadastro de login: a chave é entregue em papel pela escola. -->
                <div class="u-mt-20 chave-acesso">
                    <el-divider>ou</el-divider>

                    <el-button v-if="!mostrarChave" size="medium" type="text" @click="mostrarChave = true">
                        <i class="fas fa-key u-mr-5"></i> Entrar com chave de acesso
                    </el-button>

                    <el-form v-else @submit.native.prevent="onSubmitChave" :model="formChave"
                             ref="formChave" label-position="top" class="form-login">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item prop="chave" :rules="[$requiredBlur]" key="chave">
                                    <el-input size="medium" placeholder="Digite a chave recebida da escola"
                                              v-model="formChave.chave" maxlength="32"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <div class="u-text-right">
                                    <el-button size="medium" type="text" @click="mostrarChave = false">Voltar</el-button>
                                    <el-button style="width: 123px;" size="medium" :loading="loadingChave"
                                               class="btn-login" type="primary" native-type="submit" plain>
                                        <i class="fas fa-sign-in-alt u-mr-5"></i>
                                        Entrar
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>

            </div>
        </div>
   
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      mostrarChave: false,
      loadingChave: false,
      formChave: { chave: '' },
      // BLOCO N: os campos nascem VAZIOS. Antes vinham pré-preenchidos com uma
      // matrícula e uma senha reais, que ficavam expostas no bundle publicado.
      dados: {
          user: '',
          password: ''
      },
    };
  },
  mounted() {

    if(localStorage.getItem('pa85726549Token')){
      this.$router.push('/inicio');
    }

  },
  methods: {
    createLog(){

        try{

            let dados = {ocorrencia: 'logou no sistema' };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/log/store`, dados, this.$store.getters.getHeaderAuth).then(response => {

                this.$router.push("admin");

            }).catch((error) => { 

                this.$message({
                    message: 'Erro! Não foi possível realizar o login.',
                    type: 'error',
                    duration: 5000
                });
                
                this.loading = false; 
            });

        }catch(e){

            this.loading = false;

            this.$message({
                message: 'Erro! Não foi possível realizar o login.',
                type: 'error',
                duration: 5000
            });

        }

    },
    /**
     * BLOCO N — item 18: acesso do responsável pela chave impressa.
     * A validação é toda do backend; aqui só coletamos e mostramos a mensagem.
     */
    onSubmitChave() {

        this.$refs.formChave.validate((valid) => { if(valid){

            this.loadingChave = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/acessar-por-chave`,
                             { chave: this.formChave.chave }, this.$store.getters.getHeader).then(response => {

                this.loadingChave = false;

                if(typeof response.data.erro !== 'undefined'){
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    return;
                }

                this.$store.commit('setToken', response.data);
                localStorage.setItem('pa85726549Token', JSON.stringify(response.data));
                this.$router.push('/inicio');

            }).catch((error) => {

                this.loadingChave = false;

                // 401 é a recusa esperada; a mensagem vem do backend e é sempre genérica.
                const msg = (error && error.response && error.response.data && error.response.data.erro)
                    ? error.response.data.erro
                    : 'Não foi possível entrar com esta chave.';

                window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
            });

        }});
    },
    onSubmitLogin() {

        this.$refs.dados.validate((valid) =>{ if(valid){

            this.loading = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/autentica-portal-aluno`, this.dados, this.$store.getters.getHeader).then(response => {

              if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                window.eventBus.$emit('loading', false);
                this.loading = false; 

              }else{
               
                this.$store.commit('setToken', response.data);
                localStorage.setItem('pa85726549Token', JSON.stringify(response.data));
                this.$router.push('/inicio');
                this.loading = false; 
                // this.createLog();
              }

            }).catch((error) => {

                try{

                    this.loading = false;

                    if(error.response.status == '401'){

                    this.$message({
                        message: 'Erro! Usuário não autorizado.',
                        type: 'error',
                        duration: 5000
                    });

                    }else if(error.response.status == '429'){

                    this.$message({
                        message: 'Erro! Demasiadas solicitações em curto período de tempo.',
                        type: 'error',
                        duration: 5000
                    });

                    }else{

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                    }

                }catch(e){

                    this.loading = false;

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                }

            });
        }});
      }
  },
  components: {},
};
</script>
<style>

.container-login {
  height: 100%;
  box-sizing: border-box;
  background: url("/public/img/background-login.jpg") center right;
  background-size: cover;
  overflow: auto;
  display: flex;
}

.container-login .info {
  flex: 5;
  /* background: rgb(0 0 0 / 22%); */
}

.container-login .form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2;
  padding: 40px;
  box-sizing: border-box;
  /* background: rgb(0 0 0 / 22%); */
}

.container-login .content-form {
  margin: 30px;
  width: 440px;
}

@media (max-width: 575px) {
  .container-login .content-form {
    width: 300px;
  }
  .container-login .form {
    padding: initial;
  }
  .conteudo-banner {
    width: 100%;
    justify-content: center;
  }
  .tarja-top {
    text-align: center !important;
    padding-right: initial !important;
  }
}

.container-login .rodape-info {
  margin: 30px;
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
}

.container-login .title-rodape-info {
  font-weight: 600;
  font-size: 1.857143rem;
  line-height: 1.6;
}

.container-login .copyright {
  font-style: italic;
}

.container-login .link-e-prefeitura {
  font-weight: 700;
  color: #343a40;
  font-size: 1.428571rem;
}

.container-login .content-form h1 {
  font-weight: 700 !important;
  font-size: 1.857143rem;
  color: #171717;
  margin-bottom: 3px;
  margin-top: 30px;
}

.container-login .content-form h2 {
  color: #6b6b6b !important;
  font-weight: 400 !important;
  font-size: 1.285714rem;
  margin-top: 30px !important;
}

.container-login .lembte-me {
  color: #fff !important;
}

.form-login .el-input__inner {
  -webkit-appearance: none;
  /* background-color: rgba(255, 255, 255, 0.27); */
  color: #000;
}

.form-login .el-input__inner::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #606266;
}

.form-login .el-form-item__error {
  color: #fff;
}

.container-login .btn-login {
  color: #125a96 !important;
  background-color: #c8e2f8 !important;
  border-color: #c8e2f8 !important;
}

.container-login .btn-login:hover {
  color: #125a96 !important;
  background-color: #9acbf3 !important;
  border-color: #9acbf3 !important;
  box-shadow: none !important;
}

.container-login .links-register a {
  color: #3d4246 !important;
  transition: color 0.12s ease-out;
  margin-right: 10px;
}

</style>